import { ApiResponse } from "./api-service/api-response.model";
import { UserDetails } from "./user-details.model";
import { UserState } from "./state/user-state.model";
import { ApiConfig } from "./api-service/api-config.model";
import { ApiResult } from "./api-service/api-result.model";
import { DateRange } from "./date-range.model";

export * from "./api-base.model";

export const DEFAULT_PAGINATION = {
  pageSize: 10,
  pageNumber: 1
};

export interface IDictionary<T> {
  [id: string]: T;
}

export interface GridRow<T> {
  data: T;
}

export type PageParam = { id: string };

export type ThemeType = "dark" | "light";

export type { ApiResponse, UserDetails, UserState, DateRange };
export { ApiConfig, ApiResult };
